var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.attrs && _vm.attrs.label)?_c('p',[_vm._v(" "+_vm._s(_vm.attrs.label)+" ")]):_vm._e(),_c('v-color-picker',{attrs:{"mode":"hexa","type":"hex","hide-mode-switch":""},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }